<template>
  <BCol cols="12" v-if="codeDetails">
    <BRow class="custom-inner-table-bg-color rounded-sm py-1">
      <BCol cols="2">
        {{ codeDetails.discountCode }}
      </BCol>
      <BCol cols="1">
        {{ discountTypesEnum[codeDetails.discountType] }}
      </BCol>
      <BCol cols="1">
        {{ customFullDateConvert(codeDetails.expireDate) }}
      </BCol>
      <BCol cols="1"> {{ codeDetails.masterDiscountCashBack }}% </BCol>
      <BCol cols="1"> {{ codeDetails.maxUseCount }} بار </BCol>
      <BCol cols="1"> {{ codeDetails.usedCount }} بار </BCol>
      <BCol cols="2">
        {{ Intl.NumberFormat("en-US").format(codeDetails.minFinalPriceLimit) }}
        تومان
      </BCol>
      <BCol cols="1">
        {{
          codeDetails.discountType == 1
            ? Intl.NumberFormat("en-US").format(
                codeDetails.studentDiscountValue
              )
            : codeDetails.studentDiscountValue
        }}
        {{ discountTypeUnit[codeDetails.discountType] }}
      </BCol>
      <BCol cols="2">
        <b-link :to="`/apps/referral-discounts/${codeDetails.id}`">
          <FeatherIcon
            icon="ExternalLinkIcon"
            size="23"
            class="text-info"
          ></FeatherIcon>
        </b-link>
      </BCol>
    </BRow>
  </BCol>
</template>

<script>
export default {
  props: {
    codeDetails: {
      type: Object,
    },
  },
  data() {
    return {
      discountTypeUnit: {
        1: "تومان",
        2: "%",
      },
      discountTypesEnum: {
        1: "مبلغ",
        2: "درصد",
      },
    };
  },
  mixins: [timeConvertUtils],
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
  },
};
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BRow, BCol, BButton, BLink } from "bootstrap-vue";
</script>
